<div>
  <div class="indicators">
    <div class="dark-status">
      <span><b>Total: {{dataSource ? dataSource?.filteredData.length : 0}}</b></span>
    </div>
    <app-search-pill class="custom-table__search" (search)="applyFilter($event)"></app-search-pill>
    <mat-paginator class="spacer" [pageSizeOptions]="[50]" ></mat-paginator>
  </div>
</div>

<div class="table-container mat-elevation-z8">
  <table mat-table [dataSource]="dataSource">

    <!-- Columns -->
    @for (column of displayedColumns; track column) {
      <ng-container [matColumnDef]="column.columnKey">
        <th mat-header-cell *matHeaderCellDef> {{ column.columnName }} </th>
        <td mat-cell *matCellDef="let element"> {{element[column.columnKey]}} </td>
      </ng-container>
    }

    <!-- more Column -->
    @if (this.config.menu.length>0) {
      <ng-container matColumnDef="more" stickyEnd>
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let element; let i=index;">
          @for (item of this.config.menu; track item) {
            <button
              mat-icon-button
              [color]="item.color"
              [matTooltip]="item.display"
              (click)="action(item.action, element)"
              >
              <mat-icon>{{item.icon}}</mat-icon>
            </button>
          }
        </td>
      </ng-container>
    }

    <tr mat-header-row *matHeaderRowDef="columnsToDisplay; sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: columnsToDisplay;"></tr>

  </table>
</div>